<div class="select-computer-modal_min-height">
  <div
    class="mbs-form mb-3"
    [formGroup]="computerSearchForm">
    @if (isSpecificCase) {
      <div class="row mb-2">
        <div class="col-6">
          <mbs-company-select
            formControlName="companies"
            [disabled]="loading"
            [multiple]="true">
          </mbs-company-select>
        </div>

        <div class="col-6">
          <mbs-select
            bindLabel="name"
            formControlName="os"
            [clearable]="true"
            [isCheckboxOverflow]="true"
            [isCheckboxSelect]="true"
            [items]="osTypes"
            [multiple]="true"
            [placeholder]="'shared:placeholders.selectOS' | i18next"
            [searchable]="false"
            [showRequiredMark]="false">
          </mbs-select>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <mbs-smart-search
            [disabled]="loading"
            [manualRouteHandling]="true">
            <mbs-smart-search-tags-template> </mbs-smart-search-tags-template>
          </mbs-smart-search>
        </div>
      </div>
    } @else {
      <div class="row justify-content-between py-1 mb-3">
        <div class="col-8">
          <mbs-smart-search
            [disabled]="loading"
            [manualRouteHandling]="true">
            <mbs-smart-search-os-template *ngIf="allFilters"> </mbs-smart-search-os-template>

            <mbs-smart-search-status-template *ngIf="allFilters"> </mbs-smart-search-status-template>

            <mbs-smart-search-ip-template> </mbs-smart-search-ip-template>

            <mbs-smart-search-tags-template> </mbs-smart-search-tags-template>

            <mbs-smart-search-product-installed-template *ngIf="allFilters"> </mbs-smart-search-product-installed-template>

            <mbs-smart-search-product-not-installed-template *ngIf="allFilters"> </mbs-smart-search-product-not-installed-template>
          </mbs-smart-search>
        </div>
        <div class="col-4">
          <mbs-company-select
            formControlName="companies"
            [multiple]="true">
          </mbs-company-select>
        </div>
      </div>
    }
  </div>

  <mbs-table-grid
    [cancelSelectionText]="'shared:paging.cancelSelection' | i18next"
    [data]="data"
    [headers]="headers"
    [infiniteScroll]="true"
    [infiniteScrollDistance]="infiniteScrollDistance"
    [infiniteScrollLoading]="infiniteScrollLoading"
    [infiniteScrollThrottle]="infiniteScrollThrottle"
    [keepState]="true"
    [loading]="loading"
    [maxHeight]="'50vh'"
    [multipleSelect]="multipleSelect"
    [myTrackBy]="trackBy"
    [noDataMessage]="noDataText"
    [selectable]="true"
    [selectAllButtonText]="selectAllText()"
    [selectAllIgnoreDisabled]="true"
    [selectedCountText]="selectedText()"
    [selectedItems]="selected"
    [serverSidePagination]="false"
    [showSelectAllCheckbox]="true"
    [showSelectAllHint]="!isSpecificCase"
    [showTableCheckboxes]="true"
    [totalItems]="total"
    [virtualScrolling]="true"
    (changeSelected)="onSelectedRowsChanged($event)"
    (scrolled)="onScrolled$.next(true)"
    (selectAllOnAllPages)="selectAllOnAllPages($event)">
    <ng-template
      let-item
      mbsTableCell>
      {{ getCompName(item) }}
    </ng-template>

    <ng-template
      let-item
      mbsTableCell>
      {{ item?.company?.name ?? '-' }}
    </ng-template>
  </mbs-table-grid>
</div>
